// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconLeaf = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 66,
    width: 91,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-leaf">
      <svg
        className="c-icon-leaf fill-current"
        width={width || measurements.width}
        height={height || measurements.height} viewBox="0 0 91 66" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M37.5048 19.2426L34.07 8.88948C27.9799 6.9169 21.7492 5.2084 15.4074 3.77212L14.9738 8.58374L13.2156 3.28273C5.35064 1.56443 0 0.808472 0 0.808472C0 0.808472 7.22564 21.8129 22.3859 37.8709L40.0489 40.2423L26.327 41.7545C28.234 43.5081 30.2834 45.1684 32.463 46.7254C54.5143 62.3688 79.0758 69.5462 87.3219 62.7561C95.5681 55.9661 84.3767 37.7808 62.3254 22.139C55.4893 17.2894 46.9018 13.3978 38.3053 10.3341L37.5048 19.2426Z" fill={fill || '#E3752E'} />
      </svg>

    </Icon>
  );
};

export default IconLeaf;
